import cls from "./viewedProducts.module.scss";
import { useTranslation } from "react-i18next";
import { Product } from "interfaces";
import ProductCard from "components/productCard/productCard";
import Empty from "components/empty/empty";
import { Skeleton } from "@mui/material";
import React from "react";

type Props = {
  data: Product[];
  loading?: boolean;
};

export default function ViewedProductsContainer({
  data,
  loading = false,
}: Props) {
  const { t } = useTranslation();

  const renderView = () => {
    if (loading) {
      return (
        <div className={cls.items}>
          {Array.from(new Array(6)).map((_, index) => (
            <Skeleton
              variant="rectangular"
              key={index}
              className={cls.shimmer}
            />
          ))}
        </div>
      );
    }
    if (!data?.length) {
      return (
        <div className={cls.empty}>
          <Empty text={t("no.viewed.products")} />
        </div>
      );
    }
    return (
      <div className={cls.items}>
        {data.map((item) => (
          <ProductCard key={item?.id} data={item} />
        ))}
      </div>
    );
  };

  return (
    <div className={cls.container}>
      <h1 className={cls.title}>{t("viewed.products")}</h1>
      {renderView()}
    </div>
  );
}
